import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	starred: {
		id: 'eoc.alert-list.saved-searches.starred-section.no-translate',
		defaultMessage: 'Starred',
		description: 'Section title in alert list navigation.',
	},
	starTooltip: {
		id: 'eoc.alert-list.saved-searches.star.tooltip.no-translate',
		defaultMessage: 'Add to Starred',
		description: 'Tooltip will be displayed on star icon',
	},
	deleteTooltip: {
		id: 'eoc.alert-list.saved-searches.delete.tooltip.no-translate',
		defaultMessage: 'Delete',
		description: 'Tooltip will be displayed on delete icon',
	},

	unstarTooltip: {
		id: 'eoc.alert-list.saved-searches.unstar.tooltip.no-translate',
		defaultMessage: 'Remove from Starred',
		description: 'Tooltip will be displayed on unstar icon',
	},
	starredEmpty: {
		id: 'eoc.alert-list.saved-searches.starred-section.empty.no-translate',
		defaultMessage: 'Select the star icon next to your queues to add them here.',
		description: 'The text will be displayed inside starred section when there is no item',
	},
	sharedWithMeEmpty: {
		id: 'eoc.alert-list.saved-searches.shared-with-me-section.empty.no-translate',
		defaultMessage: "When a team member saves a search you'll see them here.",
		description: 'The text will be displayed inside shared with me section when there is no item',
	},
	createdByMeEmpty: {
		id: 'eoc.alert-list.saved-searches.created-by-me-section.empty.no-translate',
		defaultMessage: 'Your saved searches will appear here.',
		description: 'The text will be displayed inside created by me section when there is no item',
	},
	filters: {
		id: 'eoc.alert-list.saved-searches.filters-section.no-translate',
		defaultMessage: 'Default Filters',
		description: 'Section title in alert list navigation.',
	},
	sharedWithMe: {
		id: 'eoc.alert-list.saved-searches.shared-with-me-section.no-translate',
		defaultMessage: 'Shared with me',
		description: 'Section title in alert list navigation.',
	},
	createdByMe: {
		id: 'eoc.alert-list.saved-searches.created-by-me-section.no-translate',
		defaultMessage: 'Saved searches',
		description: 'Section title in alert list navigation.',
	},
	allSearch: {
		id: 'eoc.alert-list.saved-searches.all-search.no-translate',
		defaultMessage: 'All',
		description: 'Predefined search query in the alert list navigation.',
	},
	openSearch: {
		id: 'eoc.alert-list.saved-searches.open-search.no-translate',
		defaultMessage: 'Open',
		description: 'Predefined search query in the alert list navigation.',
	},
	closedSearch: {
		id: 'eoc.alert-list.saved-searches.closed-search.no-translate',
		defaultMessage: 'Closed',
		description: 'Predefined search query in the alert list navigation.',
	},
	unackedSearch: {
		id: 'eoc.alert-list.saved-searches.unacked-search.no-translate',
		defaultMessage: 'Unacknowledged',
		description: 'Predefined search query in the alert list navigation.',
	},
	notSeenSearch: {
		id: 'eoc.alert-list.saved-searches.not-seen-search.no-translate',
		defaultMessage: 'Not seen',
		description: 'Predefined search query in the alert list navigation.',
	},
	assignedToMeSearch: {
		id: 'eoc.alert-list.saved-searches.assigned.no-translate',
		defaultMessage: 'Assigned to me',
		description: 'Predefined search query in the alert list navigation.',
	},
	moreText: {
		id: 'eoc.alert-list.saved-searches.more-text.no-translate',
		defaultMessage: '+{count} more',
		description: 'Text will be displayed as see more with count',
	},
	starIconLabel: {
		id: 'eoc.alert-list.saved-searches.star.no-translate',
		defaultMessage: 'Star',
		description: 'Text is the label of action which star the saved search',
	},
	deleteIconLabel: {
		id: 'eoc.alert-list.saved-searches.delete.no-translate',
		defaultMessage: 'Delete',
		description: 'Text is the label of action which delete the saved search',
	},
	deleteModalTitle: {
		id: 'eoc.alert-list.saved-searches.delete-modal.title.no-translate',
		defaultMessage: 'Deleting saved search',
		description: 'Delete saved search modal title',
	},
	deleteModalDescription: {
		id: 'eoc.alert-list.saved-searches.delete-modal.description.no-translate',
		defaultMessage: 'You’re permanently deleting the saved search.',
		description: 'Description inside delete modal body.',
	},
});

export default messages;
